import Chart from 'react-apexcharts'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import { getISOCurrencyMain } from '../../../../utils/reducers/getters'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { preciseDecimalSum, roundNumberByParams } from '@teinor/erp/prices'
import { arrayFromDictionaryAttribute } from '../../../../utils/globals/array'
import { displayDate } from '../../../../utils/globals/date'
import { getCurrencySymbol } from '../../../../utils/globals/price'
import { SellTicketTotalVsAcceptedDaysData } from './types'
import { displayFormatedNumber } from '../../../../utils/globals/numbers'
import './sellticketacceptedvstotaldays.sass'
import { sellTicketStatusInversed } from '@teinor/erp/types/company/order/sell/sellTicket'

interface DSBSellTicketTotalVsAcceptedDaysProps extends DSBSellTicketTotalVsAcceptedDaysLogicProps {
    title?: string
}

const DSBSellTicketTotalVsAcceptedDays = ({ end_date, start_date, title }: DSBSellTicketTotalVsAcceptedDaysProps) => {
    const { t } = useTwinTranslation()
    const { sellTickets } = useDSBSellTicketTotalVsAcceptedDaysLogic({ end_date, start_date })
    const mainCurrency = getISOCurrencyMain()
    const currencySymbol = getCurrencySymbol(mainCurrency)
    const categories = sellTickets.labels

    const customlegendFormatter = (name: any) => {
        return `<div class='legend-label'>${name}</div>`
    }

    const series = [
        {
            name: t('total', 'Total'),
            data: sellTickets.sellTicketsTotal
        },
        {
            name: t('accepted', 'Aceptados'),
            data: sellTickets.sellTicketsAcceptedByDays
        },
    ]
    return (
        <div className='flex flex-col flex-auto h-1 gap-10 sell_ticket_acceptedvstotal_days'>
            <h3>{title}</h3>
            <div className='flex-auto h-1'>
                <Chart options={{
                    chart: {
                        type: 'area',
                        events: {
                            mounted: (chart) => {
                                chart.windowResizeHandler()
                            }
                        },
                        toolbar: {
                            show: false
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    yaxis: {
                        labels: {
                            style: {
                                colors: '#8F9BA4',
                                fontFamily: 'Roboto'
                            }
                        },
                    },
                    xaxis: {
                        labels: {
                            style: {
                                fontFamily: 'Roboto',
                                colors: '#8F9BA4',
                            }
                        },
                        categories
                    },
                    dataLabels: {
                        enabled: false
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'left',
                        formatter: customlegendFormatter,
                        fontFamily: 'Roboto',
                    },
                    colors: ['#7CEAEE', '#1DB27B'],
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return displayFormatedNumber(val) + ' ' + currencySymbol
                            }
                        }
                    },
                }} series={series} type="area" height={'100%'} />
            </div>
        </div>
    )
}

interface DSBSellTicketTotalVsAcceptedDaysLogicProps {
    start_date: Date
    end_date: Date
}

const useDSBSellTicketTotalVsAcceptedDaysLogic = ({ end_date, start_date }: DSBSellTicketTotalVsAcceptedDaysLogicProps) => {
    const [sellTickets, setSellTickets] = useState<SellTicketTotalVsAcceptedDaysData>({ sellTicketsTotal: [], sellTicketsAcceptedByDays: [], labels: [] })

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/tpv/sellTicket/getAllSellTicketsForStats', {
            attributes: ['total_without_vat', 'status', 'createdAt'],
            where: { 'SellTicket.createdAt': { '$betweenN': [start_date, end_date] }, is_last: true },
            order: [['createdAt', 'asc']]
        })
        const dictByDaysAccepted: TwinDictionary = {}
        const dictByDaysTotal: TwinDictionary = {}
        if (result) {
            for (const element of result) {
                const myDay = new Date(element.createdAt).toDateString()
                if (!dictByDaysTotal[myDay]) {
                    dictByDaysTotal[myDay] = {
                        name: displayDate(new Date(myDay)),
                        data: 0
                    }
                    dictByDaysAccepted[myDay] = {
                        name: displayDate(new Date(myDay)),
                        data: 0
                    }
                }
                dictByDaysTotal[myDay].data = parseFloat(roundNumberByParams(preciseDecimalSum(dictByDaysTotal[myDay].data, parseFloat(element.total_without_vat))).toFixed(2))
                if (element.status === sellTicketStatusInversed['accepted']) {
                    dictByDaysAccepted[myDay].data = parseFloat(roundNumberByParams(preciseDecimalSum(dictByDaysAccepted[myDay].data, parseFloat(element.total_without_vat))).toFixed(2))
                }
            }
            setSellTickets({ sellTicketsTotal: arrayFromDictionaryAttribute(dictByDaysTotal, 'data'), sellTicketsAcceptedByDays: arrayFromDictionaryAttribute(dictByDaysAccepted, 'data'), labels: arrayFromDictionaryAttribute(dictByDaysTotal, 'name') })
        }
    }, [setSellTickets, end_date, start_date])


    useEffect(() => {
        getData()
    }, [getData])
    return { sellTickets }
}


export default DSBSellTicketTotalVsAcceptedDays